'use client';

import { Box } from '@chakra-ui/react';
import Header from 'components/layout/header/Header';
import { isAuthenticated } from 'middlewares/auth';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import { ReactNode, useEffect, useState } from 'react';
import setedigitalApi from 'services/api/setedigitalApi';
import { Provider } from "../../components/ui/provider";
import { AuthProvider } from "../../hooks/auth";

const InstagramCarousel = dynamic(
  () => import("../../components/home/InstagramCarousel"),
  { ssr: false }
);

const Footer = dynamic(
  () => import("components/layout/footer/Footer"),
  { ssr: false }
);

const SeteDigitalFooter = dynamic(
  () => import("components/layout/footer/SeteDigitalFooter"),
  { ssr: false }
);

const WhatsAppList = dynamic(
  () => import("../../components/home/WhatsAppList"),
  { ssr: false }
);

const Toaster = dynamic(
  () => import("../../components/ui/toaster").then(mod => mod.Toaster),
  { ssr: false }
);

export default function ClientLayout({ children }: { children: ReactNode }) {
  const [allowAccess, setAllowAccess] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const checkMustUpdateEmail = async () => {
      try {
        const res = await setedigitalApi.get('/associate/me');
        if (res.data.mustUpdateEmail) {
          router.push('/email/enviar');
        } else {
          setAllowAccess(true);
        }
      } catch (err) {
        console.error('Erro ao verificar mustUpdateEmail:', err);
        setAllowAccess(true);
      }
    };

    checkMustUpdateEmail();
  }, []);

  if (!allowAccess) return null;

  return (
    <Provider>
      <AuthProvider>
        <Box bg="white-bg" w="100%" minWidth="100%" overflowX="hidden">
          <Header />
          <main>{children}</main>
          <InstagramCarousel />
          {isAuthenticated() && <WhatsAppList />}
          <Footer />
          <SeteDigitalFooter />
        </Box>
          <Toaster />
      </AuthProvider>
    </Provider>
  );
}
